import React from 'react'


export const TablePageSelector = ({currentPage, setCurrentPage, numOfPages}) => {
  return (
    <div className="pagenum">
      <ul className="pagination">
        <li className="pagearrow waves-effect hide-on-med-and-down">
          <a onClick={() => setCurrentPage(1)}>
            <i className="ion ion-ios-arrow-back"></i><i className="ion ion-ios-arrow-back"></i>
          </a>
        </li>
        <li className="pagearrow waves-effect">
          <a onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage)}>
            <i className="ion ion-ios-arrow-back"></i>
          </a>
        </li>
        {[...Array(numOfPages).keys()].map((pageIndex) => (
          <li key={pageIndex + 1}
            className={`pagenumber ${pageIndex + 1 === currentPage ? 'active' : 'waves-effect'}`}
            onClick={() => setCurrentPage(pageIndex + 1)}                
          >
            <a>{pageIndex + 1}</a>
          </li>
        ))}
        <li className="pagearrow waves-effect">
          <a onClick={() => setCurrentPage(currentPage < numOfPages ? currentPage + 1 : currentPage)}>
            <i className="ion ion-ios-arrow-forward"></i>
          </a>
        </li>
        <li className="pagearrow waves-effect hide-on-med-and-down">
          <a onClick={() => setCurrentPage(numOfPages)}>
            <i className="ion ion-ios-arrow-forward"></i><i className="ion ion-ios-arrow-forward"></i>
          </a>
        </li>
      </ul>
    </div>
  )
}